import { render } from "./FortnitePortfolioMetrics.vue?vue&type=template&id=c7735f4a&scoped=true"
import script from "./FortnitePortfolioMetrics.vue?vue&type=script&lang=js"
export * from "./FortnitePortfolioMetrics.vue?vue&type=script&lang=js"

import "./FortnitePortfolioMetrics.vue?vue&type=style&index=0&id=c7735f4a&lang=postcss&scoped=true"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7735f4a"]])

export default __exports__